<template>
  <div class="welcome-container" :class="'tab_' + getTabId">
    <div id="main" class="wizard">
      <div class="navbar p-0">
        <div class="navbar-container">
          <ul id="tabs" class="tab-list nav nav-pills mb-3" role="tablist">
            <step-layout
              v-for="item in getTabs"
              :key="item.caption"
              :step-number="item.stepNumber"
              :number-desc="item.numberDesc"
              :step-desc="item.name"
              :active="item.isActive"
              :completed="item.completed"
              :show-step="item.showStep"
            />
          </ul>
        </div>
      </div>
      <div class="clearfix" />
      <div class="nav nav-pills step-pills row mx-0 px-1">
        <component
          :is="currentTab.id"
          ref="currenTab"
          v-bind="currentTab"
          class="w-100"
          @select-tab="selectTabById"
          @complete-tabs="setCompleteTabs"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import { Tab1, Tab2, Tab3, Tab4 } from './components/tabs';
import StepLayout from './components/StepLayout';
extend('required', {
  ...required,
  message: 'Campo requerido.',
});
export default {
  name: 'WelcomeMaster',
  components: {
    Tab1,
    Tab2,
    Tab3,
    Tab4,
    StepLayout,
  },
  data: () => ({
    tabs: [
      {
        id: 'Tab1',
        name: 'Bienvenida',
        visibility: true,
        isDisabled: false,
        isActive: true,
        invalid: false,
        active: true,
        completed: false,
        showStep: true,
        stepNumber: 1,
        numberDesc: '1',
        page: {
          tabIndex: 1,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
      {
        id: 'Tab2',
        name: 'Confirmación del Estudiante',
        visibility: false,
        isDisabled: true,
        isActive: false,
        invalid: false,
        active: false,
        completed: false,
        showStep: true,
        stepNumber: 2,
        numberDesc: '2',
        page: {
          tabIndex: 2,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
      {
        id: 'Tab3',
        name: 'Cuestionario',
        visibility: false,
        isDisabled: true,
        isActive: false,
        invalid: false,
        active: false,
        completed: false,
        showStep: true,
        stepNumber: 3,
        numberDesc: '3',
        page: {
          tabIndex: 3,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
      {
        id: 'Tab4',
        name: 'Confirmación',
        visibility: false,
        isDisabled: false,
        isActive: false,
        invalid: false,
        active: true,
        completed: false,
        showStep: true,
        stepNumber: 4,
        numberDesc: '4',
        page: {
          tabIndex: 4,
          icon: 'fas fa-user-edit',
          title: 'Servicios de Transportación',
          routes: ['Inicio', 'Estudiante', 'Servicios de Transportación'],
          tooltip: 'Servicios de Transportación',
        },
      },
    ],
    canSave: false,
  }),
  computed: {
    getTabs() {
      return this.tabs.filter((t) => t.visibility);
    },
    currentTab() {
      return this.tabs.find((t) => t.isActive);
    },
    getTabId() {
      return this.currentTab?.id ?? 'na';
    },
  },
  mounted() {
    let listOfTabs = [1, 2, 3, 4];
    this.setTabVisibility(listOfTabs, true);
  },
  methods: {
    async setCompleteTabs(tabs) {
      for (let tabNumber of tabs) {
        const tab = this.getTabByNumber(tabNumber);
        this.completeTab(tab);
      }

      //active last one
      const lastTab = this.getTabByNumber(tabs[tabs.length - 1]);
      this.activateTab(lastTab, true);
    },
    selectTabById(tabNumber) {
      if (!tabNumber) return;

      const tab = this.getTabByNumber(tabNumber);
      const oldTab = this.getTabByNumber(tabNumber - 1);

      oldTab.completed = true;

      this.activateTab(tab);
      return tab;
    },
    async activateTab(tab) {
      if (tab.isActive) return;
      this.currentTab.isActive = false;
      tab.isActive = true;
    },
    async completeTab(tab) {
      tab.completed = true;
    },
    getTabByNumber(tabNumber) {
      return this.getTabs.find((t) => t.id === `Tab${tabNumber}`);
    },
    setTabVisibility(tabs, value) {
      value = value ?? true;
      this.tabs.map((s) => {
        const tabId = s.id;
        if (tabs.includes(parseInt(tabId.slice(tabId.length - 1)))) {
          s.visibility = value;
        }
        return s;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.welcome-container {
  flex: 1;
  margin: 0px !important;
}

#tabs {
  display: table;
  width: 100%;
  table-layout: fixed;
}
#tabs li {
  display: table-cell;
  cursor: pointer;
}
#tabs a {
  display: block;
  text-align: center;
}
ul.tab-list {
  border-bottom: 1px solid #e2e2e2;
}
ul.tab-list li > a.disabled {
  color: #e2e2e2;
}
i.warning {
  color: #ff5b5c;
  margin-left: 3px;
}
a.active i.warning {
  color: #fff;
}

.navbar-container {
  width: 100%;
  margin-top: 10px;
}

.step-pills {
  width: 100%;
}

.nav-tabs > li {
  width: 20%;
}
.step-pills > li {
  width: 20%;
}

.footer {
  position: relative;
  margin-top: -150px; /* negative value of footer height */
  height: 150px;
  clear: both;
  padding-top: 20px;
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .tab_Tab1,
  .tab_Tab2 {
    .fixed-bottom-container {
      position: fixed !important;
      bottom: 0 !important;
    }
  }
}

@media only screen and (max-width: 768px) {
  $singleCheckboxColor: #f2f2f2;
  .wizard {
    height: 100%;
  }

  //navbar
  ::v-deep .navbar {
    .navbar-container {
      .step-label {
        display: none;
      }
    }
  }

  //step 2
  ::v-deep .container-box {
    background: #fff;
    max-width: 100%;
    padding: 0px 20px;
    .main-title {
      text-align: center;
      strong {
        font-size: 1rem;
      }
    }
    .confirm-title {
      font-size: 1.2rem;
    }
    .message-content {
      .message-paragraph {
        font-size: 0.7rem;
      }
    }
    .action-content {
      padding: 0px !important;
      span {
        div.action-content-input {
          flex-direction: column !important;
          ::v-deep .custom-single-checkbox {
            margin-bottom: 10px;
            .checkbox-word-container {
              border-radius: 0 5px 5px 0 !important;
              p {
                font-size: 0.7rem;
              }
            }
          }
          button {
            i {
              display: none;
            }
          }
        }
        button {
          border-radius: 5px !important;
          margin-top: 10px !important;
        }
      }
    }
  }

  ::v-deep .container-box-step2 {
    background: #fff;
    padding: 0px;
    max-width: 800px !important;
    width: 85%;
    .confirm-title {
      font-size: 1.2rem;
    }
    .birthdate-section {
      .sie-section {
        width: 100%;
      }
    }
    .textfield-year {
      width: 100px;
    }
    .continue-section {
      button {
        width: 56%;
        i {
          margin-right: 0px;
        }
      }
    }
  }

  /* Step 3 */
  ::v-deep .container-box-step3 {
    .questionnaire-title {
      margin-left: 0px !important;
    }
    .question-section {
      width: 47px !important;
      min-height: 47px !important;
    }
    .question-description {
      font-size: 12pt;
      margin-bottom: 5px !important;
      padding-top: 0px !important;
    }
    .question-selection {
      margin-left: 0px !important;
      padding-top: 0px !important;

      .questionnaire-question-text {
        font-size: 0.9rem;
        margin-bottom: 10px;
      }
    }
    .question-selector-color {
      width: 100% !important;
    }

    ::v-deep .custom-radio-buttom-container {
      display: flex !important;
      flex-grow: row wrap !important;
      margin-left: 0px;
      padding-bottom: 0px;
      margin-bottom: 10px;
      .custom-radio-buttom-item {
        flex: 1;
      }
      .page-item {
        .page-link {
          width: auto;
          .legend-label {
            font-size: 0.5rem;
          }
        }
      }
    }

    ::v-deep .button-selector-wrapper {
      display: flex;
      flex-direction: row;
      justify-content: center;
    }

    .questionnaire-action {
      div:first {
        width: 100%;
      }
      button {
        width: 90% !important;
      }
    }
  }

  .tab_Tab4 {
    .fixed-bottom-container {
      position: absolute !important;
      bottom: 0 !important;
    }
  }

  /* Step 4 */
  ::v-deep .container-box-step4 {
    padding: 20px !important;
    .icon-section {
      em {
        font-size: 7rem;
      }
    }
    .message-section {
      strong {
        font-size: 1rem;
      }
      p {
        font-size: 1rem;
        margin-top: 0px;
      }
    }
  }
}

/* variations */
.tab_Tab3 {
  .wizard {
    height: 100% !important;
  }
}
</style>
